import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showNotification, Button } from 'react-admin';
import { push } from 'react-router-redux';
import dataProviderFactory from '../../dataProvider'
import { UPDATE } from 'react-admin'
import ForwardIcon from '@material-ui/icons/Forward';

class CopyTourButton extends Component {

    handleClick = async () => {
        const { push, record, showNotification } = this.props;
        const dataProvider = await dataProviderFactory('rest')
        const bodyRequest = { id: record.id,  data: { copy: true } };
        
        dataProvider(UPDATE, 'tours_copy', bodyRequest ).then((response) => {
            console.log(response)
            showNotification(`Tour copied with id: ${response.data.newId}`);
            push(`/tours/${response.data.newId}`);
        })
        .catch((e) => {
            console.error(e);
            showNotification('Error: tour not copied', 'warning')
        });
    }

    render() {
        return (
            <Button label="Copy tour" onClick={this.handleClick}> 
                <ForwardIcon/> 
            </Button>
        )
    }
}

CopyTourButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification,
    push,
})(CopyTourButton);


// WEBPACK FOOTER //
// ./src/resources/tours/copyTourButton.js